<style lang="less" scoped>
  .product-section {
    padding: 40px 0;
  }
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px 0 40px;
  }
  .title {
    font-size: 18px;
  }
  .header-left {
    display: flex;
    align-items: center;
    padding-right: 30px;
  }
  .header-button {
    font-size: 13px;
    &.active {
      border-color: #ff6c00;
      color: #ff6c00;
    }
    &:not(:first-of-type) {
      margin-left: 5px;
    }
    &.el-button {
      padding: 10px 15px 11px;
    }
  }
  .header-select {
    margin-left: 10px;
    background-color: #fff;
  }
  .tooltip {
    margin-left: 10px;
  }
  .tooltip-button {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 1px solid #dde1e3;
    background-image: url(~@/assets/icon-tip.png);
    background-size: cover;
    background-repeat: no-repeat;
  }
  .content {
    margin-top: 20px;
    padding: 0 40px;
  }
  .weekly-table {
    display: flex;
    border: 1px solid #e3e3e3;
  }
  .day-column {
    flex: 1;

    &:not(:first-of-type) {
      border-left: 1px solid #e3e3e3;
    }
  }
  .day-column-title {
    height: 51px;
    line-height: 50px;
    border-bottom: 1px solid #e3e3e3;
    background-color: #f7f7f7;
    font-size: 15px;
    color: #808080;
    text-align: center;
  }
  .product-add-button-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 120px;
    max-height: calc(100% - 51px);
  }
  .product-add-button {
    width: 40px;
    height: 40px;
    background-image: url(~@/assets/icon-add.png);
    background-size: cover;
    background-repeat: no-repeat;
  }
  .product-item-wrapper {
    max-width: 230px;
    margin: 10px 20px;
  }
</style>

<style lang="less">
  .sc-management-products-header-select {
    input.el-input__inner {
      background-color: #fff;
    }
  }
</style>

<template lang="pug">
  section.product-section
    header.header
      p.title BEST 상품 설정
      .header-left(v-if="gender === 'A'")
        el-button.header-button(:class="prodGender == 'F'?'active':''", @click="changeGender('F')") 여성상품
        el-button.header-button(:class="prodGender == 'M'?'active':''", @click="changeGender('M')") 남성상품
    .content
      .weekly-table
        .day-column(v-for="(product, index) in weekProduct")
          best-product-week-day(
            :products="weekProduct[index]",
            :idx="Number(index)",
            @deleteBestProduct="deleteBestProduct",
            @showProductList="showProductList",
          )
    product-list-dialog(
      v-if="prodGender !== null",
      :visible="visible",
      :week="week",
      :categories="cateGender",
      :gender="gender",
      :prodGender="prodGender",
      @close="visible = false",
      @selectBest="selectBestProduct"
    )
</template>

<script>
import { mapState } from 'vuex';
import ProductItem from '@/components/ProductItem.vue';
import BestProductWeekDay from '@/components/BestProductWeekDay.vue';
import ProductListDialog from '@/components/ProductListDialog.vue';
import _ from 'lodash';

export default {
  computed: {
    ...mapState({
      me: state => state.me,
      categories: state => state.categories,
    }),
  },
  components: {
    ProductItem,
    ProductListDialog,
    BestProductWeekDay,
  },
  watch: {
    prodGender() {
      for (let i = 0; i < 7; i += 1) {
        this.weekProduct[i] = [];
      }
      this.bestProductList();
    },
  },
  mounted() {
    this.gender = this.me.sgndr;
    if (this.gender === 'A') {
      this.prodGender = 'F';
      this.cateGender.push(this.categories[0]);
      this.cateGender.push(this.categories[2]);
    } else {
      this.prodGender = this.gender;
      this.cateGender = this.categories;
    }
  },
  methods: {
    // 성별 전환
    changeGender(gender) {
      this.cateGender = [];
      if (gender === 'F') {
        this.cateGender.push(this.categories[0]);
        this.cateGender.push(this.categories[2]);
      } else {
        this.cateGender.push(this.categories[1]);
        this.cateGender.push(this.categories[2]);
      }
      this.prodGender = gender;
    },

    // 전체상품
    showProductList(week) {
      this.week = week;
      this.visible = true;
    },

    async bestProductList() {
      const bestProductList = await this.$http.get('/api/mkc/v1/best-products', { params: { gndr: this.prodGender } });
      bestProductList.data.data.forEach((v) => {
        this.weekProduct[v.weekDay].push(v);
      });
    },

    // BEST 상품 선택
    selectBestProduct: _.debounce(async function selectBestProduct(product, week) {
      try {
        await this.$http.post('/api/mkc/v1/best-products', {
          week,
          gndr: this.prodGender,
          seq: product.prodSeq,
          order: this.weekProduct[week].length + 1,
        });
        product.weekDay = week;
        this.weekProduct[week].push(product);
        this.visible = false;
      } catch (e) {
        // '같은 날 동일상품은 등록 할 수 없습니다.'
        this.$alert('같은 날 동일상품은 등록 할 수 없습니다.', {
          confirmButtonText: '확인',
        });
      }
    }, 300),

    // BEST 상품 삭제
    async deleteBestProduct(product, index) {
      try {
        await this.$http.post('/api/mkc/v1/best-products-delete', {
          week: product.weekDay,
          gndr: product.prodGender,
          seq: product.prodSeq,
        });
        this.weekProduct[product.weekDay].splice(index, 1);
      } catch (e) {
        this.$alert(e.response.data.message, {
          confirmButtonText: '확인',
        });
      }
    },
  },
  data() {
    return {
      visible: false,
      fixedSet: 1,
      week: 0,
      edit: false,
      gender: null,
      prodGender: null,
      cateGender: [],
      weekProduct: {
        0: [],
        1: [],
        2: [],
        3: [],
        4: [],
        5: [],
        6: [],
      },
    };
  },
};
</script>
